import React, { useState, useEffect } from "react";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import BadgeIcon from "@mui/icons-material/Badge";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import ArchiveIcon from "@mui/icons-material/Archive";
import TuneIcon from "@mui/icons-material/Tune";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import BackgroundColorPicker from "../BackgroundColorPicker/BackgroundColorPicker";
import HelpMenu from "./menus/HelpMenu";
import MembersModal from "./menus/MembersModal";
import EditBoardMenu from "./menus/EditBoardMenu";
import PermissionsMenu from "./menus/PermissionsMenu";
import CryptoJS from "crypto-js";
import getCookie from "../../../hooks/getCookie";
import Checkbox from "@mui/material/Checkbox";

export default function MenuLateralPadrao({ abrirArquivado }) {
  const [backgroundPickerOpen, setBackgroundPickerOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(
    document.body.classList.contains("dark")
  );
  const [collapsed, setCollapsed] = useState(true);
  const [alert2, setAlert2] = React.useState(null);
  const [helpDialogOpen, setHelpDialogOpen] = useState(false);
  const [membersDialogOpen, setMembersDialogOpen] = useState(false);
  const [permissaoDialogOpen, setPermissaoDialogOpen] = useState(false);
  const [editBoardDialogOpen, setEditBoardDialogOpen] = useState(false);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);

  const userId = getCookie("userId");
  const permissao = getCookie("permissao");
  const username = getCookie("username");
  const sessionId = getCookie("session_id");

  const decryptData = (data) => {
    const bytes = CryptoJS.AES.decrypt(data, "secret-key");
    return bytes.toString(CryptoJS.enc.Utf8);
  };
  const handleToggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  const ou = decryptData(localStorage.getItem("ou"));

  const handleTuneIconClick = () => {
    setBackgroundPickerOpen(true);
  };

  const handleBackgroundPickerClose = () => {
    setBackgroundPickerOpen(false);
  };

  const getTextColor = (hexColor) => {
    if (!hexColor) return "#000"; // fallback
    const r = parseInt(hexColor.slice(1, 3), 16);
    const g = parseInt(hexColor.slice(3, 5), 16);
    const b = parseInt(hexColor.slice(5, 7), 16);
    const brightness = (r * 299 + g * 587 + b * 114) / 1000;
    return brightness > 128 ? "#000" : "#fff";
  };
  const textColor = getTextColor(isDarkMode ? "#1e1e1e" : "#f2f2f2");

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
  };

  const validateFields = () => {
    return true; // Ajuste conforme necessário
  };

  const handleHelpDialogOpen = () => {
    setHelpDialogOpen(true);
  };

  const handleHelpDialogClose = () => {
    setHelpDialogOpen(false);
  };

  const handleMembersDialogOpen = () => {
    setMembersDialogOpen(true);
  };

  const handleMembersDialogClose = () => {
    setMembersDialogOpen(false);
  };

  const handlePermissaoDialogOpen = () => {
    setPermissaoDialogOpen(true);
  };

  const handlePermissaoDialogClose = () => {
    setPermissaoDialogOpen(false);
  };

  const handleEditBoardDialogOpen = () => {
    setEditBoardDialogOpen(true);
  };

  const handleEditBoardDialogClose = () => {
    setEditBoardDialogOpen(false);
  };

  const handleFeedbacksDialogOpen = () => {
    setFeedbackDialogOpen(true);
  };

  const handleFeedbacksDialogClose = () => {
    setFeedbackDialogOpen(false);
  };

  return (
    <>
      <div className={`menu-direito `}>
        <ul className="ul-menu-direito text-navbar-options">
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleTuneIconClick}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <TuneIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Ajustes do Quadro" />
          </MenuItem>
          <MenuItem
            sx={{ color: textColor }}
            className="text-navbar-options"
            onClick={abrirArquivado}
          >
            <ListItemIcon>
              <ArchiveIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Arquivados" />
          </MenuItem>
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleMembersDialogOpen}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <PeopleAltIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Membros" />
          </MenuItem>

          <MenuItem
            sx={{ color: textColor }}
            onClick={handlePermissaoDialogOpen}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <BadgeIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Permissões" />
          </MenuItem>
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleEditBoardDialogOpen}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <AppRegistrationIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Editar Quadro" />
          </MenuItem>
          <MenuItem
            sx={{ color: textColor }}
            onClick={handleHelpDialogOpen}
            className="text-navbar-options"
          >
            <ListItemIcon>
              <LiveHelpIcon
                sx={{ color: textColor }}
                className="text-navbar-options"
              />
            </ListItemIcon>
            <ListItemText primary="Ajuda" />
          </MenuItem>
        </ul>
      </div>
      <BackgroundColorPicker
        open={backgroundPickerOpen}
        onClose={handleBackgroundPickerClose}
        //currentColor={boardBackgroundColor}
        //onColorChange={updateBoardBackground}
      />
      {editBoardDialogOpen == true && (
        <EditBoardMenu
          //openTitle={openTitle}
          // openDescription={"Descrição"}
          // anchorElTitle={anchorElTitle}
          // anchorElDescription={anchorElDescription}
          // handleClickTitle={handleClickTitle}
          // handleClickDescription={handleClickDescription}
          // handleCloseTitle={handleCloseTitle}
          // handleCloseDescription={handleCloseDescription}
          // handleTitleSubmit={handleTitleSubmit}
          // handleDescriptionSubmit={handleDescriptionSubmit}
          // setTitle={setTitle}
          // setDescription={setDescription}
          handleEditBoardDialogClose={handleEditBoardDialogClose}
        />
      )}
      {membersDialogOpen && (
        <MembersModal
          handleMembersDialogClose={() => setMembersDialogOpen(false)}
          CustomCheckbox={Checkbox} // ✅ passa o componente válido
        />
      )}

      {helpDialogOpen == true && (
        <HelpMenu handleHelpDialogClose={handleHelpDialogClose} />
      )}

      {permissaoDialogOpen == true && (
        <PermissionsMenu
          username={username}
          handlePermissaoDialogClose={handlePermissaoDialogClose}
        />
      )}
    </>
  );
}
